// ##### Komarov 2025-07-21
import React from 'react';
// ##### 25-05-21 Komarov
import SmallScreenSearch from './SmallScreenSearch';

// ##### Komarov 2025-07-21
const SmallScreenSearchTag = ({ wrapper, datepickerClass, switcherRef }) => {
  return (
    <SmallScreenSearch
      //  ##### 22-11-14 Komarov
      wrapper={wrapper}
      innerWrapper="formInnerWrapper_inner"
      formClass="mySearch_inner"
      autocompleteClass={null}
      datepickerClass={datepickerClass}
      switcherRef={switcherRef}
    />
  );
};

export default SmallScreenSearchTag;
